import type { ReactNode, FC } from 'react';

import { cn } from './cn.js';

export interface PageHeadProps {
  title: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

/** Заголовок страницы: название, подпись и действия справа. Соответствует .page-header макета. */
export const PageHead: FC<PageHeadProps> = ({
  title,
  sub,
  actions,
  className,
}) => (
  <div
    className={cn('mb-[22px] flex items-end justify-between gap-4', className)}
  >
    <div>
      <h1 className="m-0 text-[22px] font-[650] tracking-[-0.015em] text-ink-900">
        {title}
      </h1>
      {/* Нижний отступ - браузерный у абзаца .page-sub макета (1em): без него
          содержимое под заголовком поднимается на 13px. */}
      {sub != null && (
        <p className="mt-1 mb-[1em] text-[13px] text-ink-500">{sub}</p>
      )}
    </div>
    {actions != null && (
      <div className="flex items-center gap-2">{actions}</div>
    )}
  </div>
);
